// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pcpdaClass[data-v-c94f9e42] {\n  line-height: 17px;\n  font-size: 17px;\n  padding: 5px;\n  background: -webkit-gradient(linear, left top, right top, from(#ededed), to(#fff));\n  background: linear-gradient(to right, #ededed, #fff);\n}\n.el-tree[data-v-c94f9e42] {\n  min-width: 100%;\n  display: inline-block;\n}\n.tree[data-v-c94f9e42] {\n  overflow: auto;\n  max-height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
